import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import './RequireAuth.css';

/** Route guard: blocks the app shell until a session is confirmed; bounces to /login. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { identity, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth-gate" role="status" aria-live="polite">
        <span className="auth-gate__spinner" aria-hidden="true" />
        Checking your session…
      </div>
    );
  }
  if (!identity) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
